import { createModel } from "hox";
import { useState, useEffect } from "react";
import { IMaintenanceDetail, IMaintenanceSearch } from "./maintenanceType";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, } from "@/utils/constants";
import { TablePaginationConfig } from "antd/es/table/interface";
import { transPgToPagination, repairFormatNum } from "@/utils/utils";
import { ISearchPage } from "@/types/ScmTypes";
import { maintenanceService } from "./maintenanceService";
import { message } from "antd";
import useGlobalModel from "@/model/globalModel";
import { sourceAppOrBranch } from "@/types/VrmSaDictEnums";
import { convertRes2Blob } from "@/utils/exportFile";
import { useLockFn } from "ahooks";
export interface IDescTotal {
    discountTotalAmount: number, // 321.94
    receivableAmount: number, // 2390.3
    receivableTotalAmount: number, // 7970.01
    totalAmount: number, // 8291.94
    workHour: number,
    materialNum: number
}
export interface IPrint {
    visible: boolean,
    type: number,
}
export const useMaintenanceModel = createModel(function () {
    const { shopAndOrg, setLoadingInfo } = useGlobalModel(({ shopAndOrg }) => [shopAndOrg]);
    const [print, setPrint] = useState<boolean>(false);
    const initDesc = {
        discountTotalAmount: 0, // 321.94
        receivableAmount: 0, // 2390.3
        receivableTotalAmount: 0, // 7970.01
        totalAmount: 0, // 8291.94
        workHour: 0,
        materialNum: 0
    }

    useEffect(() => {
        reset();
    }, [shopAndOrg.shopCode])

    const initSearchParam: IMaintenanceSearch = {};
    const initDataSource: IMaintenanceDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //查询条件
    const [searchParam, setSearchParam] = useState<IMaintenanceSearch>(initSearchParam);
    const [printParam, setPrintParam] = useState<IMaintenanceSearch>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IMaintenanceDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //表格选中的值
    const [selectedRow, setSelectedRow] = useState<IMaintenanceDetail>({});
    const [descTotal, setDescTotal] = useState<IDescTotal>(initDesc);
    //选中的数据统计展示的数据
    const [rowsDescTotal, setRowsDescTotal] = useState<IDescTotal>(initDesc);
    const [descRows, setDescRows] = useState<IMaintenanceDetail[]>([]);

    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const [loading, setLoading] = useState<boolean>(false);

    //维修单打印
    const [printVisible, setPrintVisible] = useState<boolean>(false);
    //结算单打印
    const [printSettleVisible, setPrintSettleVisible] = useState<boolean>(false);

    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.id === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        setSelectedRow(selectedData as IMaintenanceDetail)
    }, [selectedRowKeys, dataSource])

    useEffect(() => {
        let newRowsDescTotal = initDesc
        descRows.forEach((item) => {
            let { discountTotalAmount, receivableTotalAmount, receivableAmount, totalAmount, materialNum, workHour } = item
            newRowsDescTotal.discountTotalAmount += +repairFormatNum(discountTotalAmount)
            newRowsDescTotal.receivableAmount += +repairFormatNum(receivableAmount)
            newRowsDescTotal.receivableTotalAmount += +repairFormatNum(receivableTotalAmount)
            newRowsDescTotal.totalAmount += +repairFormatNum(totalAmount)
            newRowsDescTotal.workHour += +repairFormatNum(workHour)
            newRowsDescTotal.materialNum += +repairFormatNum(materialNum)
        })
        setRowsDescTotal(newRowsDescTotal)
    }, [descRows])

    const updateSearchParam = (updateParam: IMaintenanceSearch) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        loadData(initPgCfg, {});
        setSelectedRowKeys([])
    }
    const reset = () => {
        setSearchParam(initSearchParam);
        setSelectedRowKeys([])
    }
    const loadData = async (page?: ISearchPage, searchValue: IMaintenanceSearch = searchParam) => {
        setLoading(true)
        const shopParam = {
            shopType: searchValue.shopId !== undefined ? 1 : shopAndOrg.shopType,
            shopId: searchValue.shopId ?? shopAndOrg.shopId
        };
        const searchParams = {
            ...searchValue,
            ...shopParam,
            ...sourceAppOrBranch,
            brandCodes: searchValue.brandCode ? searchValue.brandCode.toString() : undefined,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        setPrintParam(searchParams);
        let { retData } = await maintenanceService.page(searchParams);
        const { records, ...pg } = retData;
        setLoading(false)
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
        // loadTotal(searchParams);
    }
    const loadTotal = async (searchParams: any) => {
        let { retData: statistics } = await maintenanceService.total(searchParams);
        setDescTotal(statistics)
    }
    const invalidateData = async (obj: object) => {
        let { retData } = await maintenanceService.invalidate(obj)
        if (retData) {
            message.success("作废成功");
            loadData();
        }
    }
    const tran = useLockFn(async (obj: object) => {
        let { retData } = await maintenanceService.tran(obj)
        loadData();
        return retData
    })
    const tranOut = useLockFn(async (obj: string) => {
        let { retData } = await maintenanceService.tranOut(obj)
        loadData();
        return retData
    })
    const exportMaintenance = async (searchValue: IMaintenanceSearch = searchParam) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
        const searchParams = {
            ...searchValue,
            ...shopAndOrg,
            brandCodes: searchValue.brandCode ? searchValue.brandCode.toString() : undefined,
            id: selectedRowKeys.join(),
        }
        try {
            let result = await maintenanceService.export(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result)
        } catch (error) {
            setLoadingInfo({ loadingVisible: false, txt: "" });
        }

    }
    const [scaniaPrint, setScaniaPrint] = useState<IPrint>({ visible: false, type: 1 });
    const [settleScaniaPrint, setSettleScaniaPrint] = useState<boolean>(false);

    const detailsExport = async (searchValue: IMaintenanceSearch = searchParam) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
        const shopParam = {
            shopType: searchValue.shopId !== undefined ? 1 : shopAndOrg.shopType,
            shopId: searchValue.shopId ?? shopAndOrg.shopId
        };
        try {
            const searchParams = {
                ...searchValue,
                ...shopParam,
                brandCodes: searchValue.brandCode ? searchValue.brandCode.toString() : undefined,
                id: selectedRowKeys.join(),
            }
            let result = await maintenanceService.detailsExport(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result)
        } catch (error) {
            setLoadingInfo({ loadingVisible: false, txt: "" });
        }

    }
    const detailsNoPriceExport = async (searchValue: IMaintenanceSearch = searchParam) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
        const shopParam = {
            shopType: searchValue.shopId !== undefined ? 1 : shopAndOrg.shopType,
            shopId: searchValue.shopId ?? shopAndOrg.shopId
        };
        try {
            const searchParams = {
                ...searchValue,
                ...shopParam,
                brandCodes: searchValue.brandCode ? searchValue.brandCode.toString() : undefined,
                id: selectedRowKeys.join(),
            }
            let result = await maintenanceService.detailsNoPriceExport(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result)
        } catch (error) {
            setLoadingInfo({ loadingVisible: false, txt: "" });
        }

    }
    const ExportOfOutboundLedger = async (searchValue: IMaintenanceSearch = searchParam) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
        const shopParam = {
            shopType: searchValue.shopId !== undefined ? 1 : shopAndOrg.shopType,
            shopId: searchValue.shopId ?? shopAndOrg.shopId
        };
        try {
            const searchParams = {
                ...searchValue,
                ...shopParam,
                brandCodes: searchValue.brandCode ? searchValue.brandCode.toString() : undefined,
                id: selectedRowKeys.join(),
            }
            let result = await maintenanceService.ExportOfOutboundLedger(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result)
        } catch (error) {
            setLoadingInfo({ loadingVisible: false, txt: "" });
        }

    }
    const mainRepairFormExport = async (searchValue: IMaintenanceSearch = searchParam) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
        const shopParam = {
            shopType: searchValue.shopId !== undefined ? 1 : shopAndOrg.shopType,
            shopId: searchValue.shopId ?? shopAndOrg.shopId
        };
        try {
            const searchParams = {
                ...searchValue,
                ...shopParam,
                brandCodes: searchValue.brandCode ? searchValue.brandCode.toString() : undefined,
                id: selectedRowKeys.join(),
            }
            let result = await maintenanceService.mainRepairFormExport(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result)
        } catch (error) {
            setLoadingInfo({ loadingVisible: false, txt: "" });
        }

    }
    return {
        searchParam,
        dataSource,
        selectedRowKeys,
        selectedRow,
        pgCfg, loading,
        initPgCfg,
        setSearchParam,
        setDataSource,
        setSelectedRowKeys,
        setSelectedRow,
        setPgCfg,
        updateSearchParam,
        resetSearchParam,
        loadData,
        invalidateData,
        tran,
        print, setPrint,
        exportMaintenance,
        descTotal, setDescTotal,
        scaniaPrint, setScaniaPrint,
        settleScaniaPrint, setSettleScaniaPrint,
        detailsExport,
        detailsNoPriceExport,
        ExportOfOutboundLedger,
        mainRepairFormExport,
        rowsDescTotal, setRowsDescTotal,
        descRows, setDescRows,
        reset,
        printVisible, setPrintVisible,
        printSettleVisible, setPrintSettleVisible,
        printParam, setPrintParam, tranOut
    }
})